import { Api } from '../lib/api/api';
export const getOverview = (token) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_OVERVIEW',
  });

  try {
    const overview = await api.users.getOverview();
    dispatch({
      type: 'GET_OVERVIEW_SUCCESS',
      overview
    });
  } catch (error) {
    dispatch({
      type: 'GET_OVERVIEW_ERROR',
    });
  }
};




